import React from "react";
import { useTranslation } from "react-i18next";
import {
  useActivateResource,
  useResourceRetrieval,
} from "@planzone/view-models";
import { Resource } from "@planzone/dto";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import { InfoResource } from "./infoResource";
import styles from "./styles.scss";
import { Safeguard } from "@scenes/safeguard";
import { UseCases } from "@planzone/core";

function ResourceActivation({ planzoneResource, cancel }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending: isResourceRetrievalPending,
    isRequestSuccess,
    isRequestFailure,
    resource,
    retrieveResource,
  } = useResourceRetrieval(planzoneResource.uuid);
  const { isRequestPending, activateResource } =
    useActivateResource(planzoneResource);
  const [formData, setFormData] = React.useState<Resource>(planzoneResource);

  React.useEffect(() => {
    !isResourceRetrievalPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveResource(planzoneResource.uuid);
  }, [planzoneResource.uuid]);

  React.useEffect(() => {
    setFormData(planzoneResource);
  }, [planzoneResource]);

  return (
    <Modal header={t("activateResource.title")} close={cancel}>
      <Safeguard useCases={[UseCases.activateResource]}>
        {({ canActivateResource }) => (
          <div className={styles.projectResourceActivaton}>
            <div className={styles.body}>
              <div className={styles.group}>
                <p className={styles.warning}>
                  {t("activateResource.warning")}
                </p>
              </div>
              <InfoResource
                resource={isRequestSuccess ? resource : planzoneResource}
              />
            </div>
            {canActivateResource && (
              <div className={styles.footer}>
                <Button type="cancel" press={cancel}>
                  {t("activateResource.cancel")}
                </Button>
                <Button
                  type={"submit"}
                  status={isRequestPending ? "pending" : "none"}
                  isDisabled={isRequestPending}
                  press={() =>
                    activateResource({
                      resource: planzoneResource,
                      nextResource: { ...formData, deactivated: false },
                    })
                  }
                >
                  {t("activateResource.save")}
                </Button>
              </div>
            )}
          </div>
        )}
      </Safeguard>
    </Modal>
  );
}

export { ResourceActivation };
